import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import MovieCategory from "@/pages/category/movie/page";
import TvCategory from "@/pages/category/tv/page";
import ReviewCategory from "@/pages/category/review/page";
import NewsDetail from "@/pages/detail/NewsDetail";
import WorkDetail from "@/pages/detail/WorkDetail";
import ReviewDetail from "@/pages/detail/ReviewDetail";
import SearchPage from "@/pages/search/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/movie", element: <MovieCategory /> },
      { path: "category/tv", element: <TvCategory /> },
      { path: "category/review", element: <ReviewCategory /> },
      { path: "detail/news/:id", element: <NewsDetail /> },
      { path: "detail/work/:id", element: <WorkDetail /> },
      { path: "detail/review/:id", element: <ReviewDetail /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;